const maxTime = 1200000;
const FORM_TRACKING_KEY = "wc_form_tracking";

/**
* @example isFormElement(event.target.tagName);
* @returns true if the nodeType is a form element
*/
export function isFormElement(nodeType) {
  switch (nodeType) {
    case "SELECT":
    case "INPUT":
    case "BUTTON":
    case "TEXTAREA":
    case "OPTION":
    case "LABEL":
    case "FIELDSET":
      return true;
    default:
      return false;
  }
}

/**
 * @example dataLayerPush({ event: "formStart", name, step: 'start', desc, value: 0.0, error: null, type });
*/
// push data to the dataLayer
export function dataLayerPush(options) {
  const { event, ...rest } = options;
  window.dataLayer.push({
    event: options.event,
    action: {
      time: new Date().toISOString(),
      ...rest,
    },
  });
}

/**
* @example handleFormSteps(name, step, desc, error, value, type);
*/
export function handleFormSteps(name, step, desc = "", error = null, value = 0.0, type = "form") {
  let isReload = performance.getEntriesByType("navigation")[0].type === 'reload';
  if (!isReload && document.referrer !== window.location.href) {
    removeTracking()
  }
  let isFresh = formIsFresh(name)
  let isNewStep = hasNavigatedToNewStep(name, step)
  let isComplete = step === "complete";

  if (!isReload && document.referrer !== window.location.href) {
    isFresh = true;
    removeTracking();
    setFormTracking(name, step);
  }
  if (!isNewStep && !error) return;
  if (isComplete && isNewStep && !error) {
    handleFormComplete({ name, type, desc, value })
    return;
  }

  if (isFresh) {
    dataLayerPush({ event: "formStart", name, step: 'start', desc, value: 0.0, error: null, type });
  }
  if ((isNewStep || isFresh) && !isComplete && !error) {
    dataLayerPush({ event: "formStep", name, step, desc, value, error, type });
  }

  if (error) {
    handleFormErrors({ name, step, errors: desc ?? ['server error'], type })
  }
  setFormTracking(name, step);
}

function getFormTracking(formName) {
  let dataString = sessionStorage.getItem(FORM_TRACKING_KEY);
  if (dataString) {
    let data = JSON.parse(dataString)
    if (data.formName === formName) {
      return data
    } else {
      removeTracking();
    }
  }
}

export function setFormTracking(formName, formStep) {
  sessionStorage.setItem(FORM_TRACKING_KEY, JSON.stringify({
    formName,
    savedStep: formStep,
    expiry: Date.now() + maxTime,
  }));
}

export function formIsFresh(formName) {
  let formData = getFormTracking(formName);
  if (!formData) {
    return true
  }
  if (formName !== formData.formName) {
    removeTracking();
    return true;
  }
  return formData.expiry <= Date.now();
}
export function hasNavigatedToNewStep(formName, formStep) {
  let formData = getFormTracking(formName);
  if (!formData) {
    return true
  }
  return formData.formName === formName && formData.savedStep !== formStep;
}

function removeTracking() {
  sessionStorage.removeItem(FORM_TRACKING_KEY);
}

// export function handleFormStart({ name, step, desc = "", type = "form" }) {
//   dataLayerPush({ event: "formStart", name, step: 'start', desc: "", value: 0.0, error: null, type });
//   dataLayerPush({ event: "formStep", name, step, desc, value: 0.0, error: null, type });
//   setFormTracking(name, step);
// }

// export function handleFormStep({ name, step, desc = "", type = "form" }) {
//   dataLayerPush({ event: "formStep", name, step, desc, value: 0.0, error: null, type });
//   setFormTracking(name, step);
// }

export function handleFormComplete({ name, type = "form", desc = "", value = 0.0, records = "1/1" }) {
  dataLayerPush({ event: "formComplete", name, step: "complete", desc, value, error: null, type, records });
  removeTracking();
}

// export function handleFormPartial({ name, errors, type = "form", desc = "", value = 0.0 }) {
//   let error = getError(errors);
//   dataLayerPush({ event: "formPartial", name, step: "complete - partial", desc, value, error, type });
//   removeTracking();
// }

export function handleFormErrors({ name, step, errors, type = "form" }) {
  let error = getError(errors);
  if (error) {
    dataLayerPush({ event: "formError", name, step: `${step} - error`, desc: "", value: 0.0, error, type });
    if (step === "complete") {
      removeTracking();
    } else {
      setFormTracking(name, step)
    }
  }
}



/**
 * @example getError([form.querySelectorAll('.error_msg, .field-validation-error, .wc-assist--error')]);
 * @returns a string of errors or null
 */
function getError(errors) {
  if (errors) {
    return errors.join(",")
  }
  return null;
}

// export const updateGtm = args => {
  //   if (window && window.digitalData) {
  //       window.digitalData.tool = { name: args.tool };
  //       if (args.step) {
  //           window.digitalData.tool.step = args.step;
  //       }
  //       dataLayer.push({ event: args.event })
  //   }
  // }
  
  // export const updateGtmWithResult = args => {
  //   if (window && window.digitalData) {
  //       window.digitalData.tool = { name: args.name, result: args.result };
  //       if (args.step) {
  //           window.digitalData.tool.step = args.step;
  //       }
  //       dataLayer.push({ event: args.event })
  //   }
  // }